var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyFreeWifi = function SvgHappyFreeWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898B91",
    fillRule: "nonzero",
    d: "M11.68 15.176a1.707 1.707 0 1 1 0 3.413 1.707 1.707 0 0 1 0-3.413M8.18 12.7a4.95 4.95 0 0 1 5.127-1.168c.703.242 1.343.64 1.87 1.165a.855.855 0 0 1-.603 1.458l-.112-.008a.85.85 0 0 1-.49-.24l-.064-.054-.065-.053a3.24 3.24 0 0 0-4.456.106.85.85 0 0 1-.604.25l-.113-.007a.854.854 0 0 1-.489-1.45zm-1.93-2.613a7.69 7.69 0 0 1 10.858 0c.16.16.25.377.25.603v.02a.846.846 0 0 1-.85.833l-.112-.007a.86.86 0 0 1-.492-.242 5.98 5.98 0 0 0-8.447 0 .854.854 0 0 1-1.206-1.207zM4.318 7.473c4.069-4.059 10.655-4.059 14.724 0a.853.853 0 0 1-1.207 1.208 8.714 8.714 0 0 0-12.31 0 .854.854 0 0 1-1.207-1.208"
  }))));
};
export default SvgHappyFreeWifi;